import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  line {
    pointer-events: none;
  }
  .axis-grid line,
  .axis-grid text,
  .domain {
    stroke: #ccdde6;
  }
  .y .tick text {
    stroke: none;
    fill: #919eaa;
  }
  .x .tick text {
    stroke: none;
    fill: #919eaa;
  }
  .axis-grid text {
    font-size: 14px;
    transform: translate(8px, 2px);
  }
  .bar:hover {
    fill: rgba(32, 171, 210, 0.8);
  }
  .y.axis-grid {
  }
  .vertical-chart {
    .x.axis-grid text {
      transform: translateY(10px);
    }
  }
  .tooltip {
    opacity: 0;
    font-size: 14px;
    position: absolute;
    white-space: nowrap;
  }
  .horizontal-chart .label {
    border: 1px solid red;
  }

  .horizontal-chart-label,
  .vertical-chart-label {
    position: absolute;
  }
  .vertical-chart-label {
    hyphens: auto;
    padding: 0 10px 0;
    transform: translateY(50%);
  }
  .horizontal-chart-label {
    font-size: 14px;
    color: #919eaa;
    bottom: -26px;
  }
`;

export default Wrapper;
